(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const revealAll = () => {
    document.querySelectorAll('[data-itcc-animate]').forEach((el) => {
      el.classList.add('is-inview');
    });
  };

  const init = () => {
    const targets = [...document.querySelectorAll('[data-itcc-animate]')];
    if (!targets.length) return;

    if (reduce.matches || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    targets.forEach((el) => {
      // Hero / above-the-fold: reveal immediately for smoother first paint
      if (el.hasAttribute('data-itcc-animate-eager') || el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        el.classList.add('is-inview');
        return;
      }
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  reduce.addEventListener?.('change', (e) => {
    if (e.matches) revealAll();
  });

  document.addEventListener('shopify:section:load', init);
})();
